import { Component, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ApiService } from "src/app/services/api.service";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import endpoints from "src/app/helpers/endpoints";
import { takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import { StorageService } from "src/app/services/storage.service";
import { FormControl, FormGroup } from "@angular/forms";
import * as moment from "moment";
import { MatTabChangeEvent } from "@angular/material/tabs";

@Component({
  selector: "fury-claim-user-dashboard",
  templateUrl: "./claim-user-dashboard.component.html",
  styleUrls: ["./claim-user-dashboard.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ClaimUserDashboardComponent implements OnInit, OnDestroy {
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  itemList: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  ngUnsubscribe = new Subject<void>();
  kpiData: any = {};
  claimUserId = "";
  tabNameList = {
    myClaims: "My Claims",
    openClaims: "Open Claims",
    purchaseClaim: "Purchase Claims",
    payoutClaims: "Payout Claims"
  }
  tabName = this.tabNameList.myClaims;
  today = new Date();
  startDate: any;
  endDate: any;
  dateRangeForm = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  claimSearchForm = new FormGroup({
    agreementNumber: new FormControl(""),
    claimNumber: new FormControl(""),
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    phoneNumber: new FormControl(""),
    emailAddress: new FormControl(""),
    address: new FormControl(""),
    city: new FormControl(""),
    state: new FormControl(""),
    zip: new FormControl(""),
    coveredItem: new FormControl(""),
    status: new FormControl(""),
  });
  services = [];

  constructor(
    private apiservice: ApiService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.router.onSameUrlNavigation = "reload";
    this.claimUserId = this.storageService.getUser()?.userId;
    if (this.claimUserId) {
      this.getFileClaimList();
      this.getKpiData();
    }
    this.getServices();
  }

  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getFileClaimList();
  }

  getFileClaimList() {
    const {
      firstName,
      lastName,
      claimNumber,
      agreementNumber,
      phoneNumber,
      emailAddress,
      address,
      city,
      state,
      zip,
      status,
      coveredItem,
    } = this.claimSearchForm.value;
    const queryParams = `?page=${Number(this.pageIndex) + 1}&size=${
      this.pageSize
    }&firstName=${firstName}&lastName=${lastName}&claimNumber=${claimNumber}&agreementNumber=${agreementNumber}&phoneNumber=${phoneNumber}&emailAddress=${emailAddress}&address=${address}&city=${city}&state=${state}&zip=${zip}&status=${status}&coveredItem=${coveredItem}${this.tabName !== this.tabNameList.openClaims && this.startDate && this.endDate ? `&startDate=${this.startDate}&endDate=${this.endDate}` : ""}&isOpenClaim=${this.tabName === this.tabNameList.openClaims ? 1 : 0}`;
    this.apiservice
      .get(
        `${endpoints.fileAClaim.getFileClaimList}/${this.claimUserId}${queryParams}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            if (res?.body?.fileClaims) {
              this.itemList = res?.body?.fileClaims?.data || [];
              this.totalCount = res?.body?.fileClaims.total;
              this.cdr.detectChanges();
            } else {
              this.itemList = undefined;
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.apiservice.alert(err.message, ErrorType.Error);
        }
      );
  }
  getKpiData() {
    this.apiservice
      .get(`${endpoints.fileAClaim.getClaimKpiData}/${this.claimUserId}${this.startDate && this.endDate ? `?startDate=${this.startDate}&endDate=${this.endDate}` : ""}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.kpiData = res.body;
        },
        error: (err: HttpErrorResponse) => {
          this.apiservice.alert(err.error?.message, ErrorType.Error);
        },
      });
  }

  tabChange(event: MatTabChangeEvent) {
    this.pageIndex = 0;
    this.tabName = event.tab?.textLabel;
    this.claimSearchForm.setValue(this.claimSearchForm.value as any);
    if(this.tabName !== this.tabNameList.purchaseClaim && this.tabName !== this.tabNameList.payoutClaims) this.getFileClaimList();
    if(this.tabName === this.tabNameList.myClaims) this.getKpiData();
  }
  fetchClaimData(event: boolean) {
    if (event) this.getFileClaimList();
  }
  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    this.startDate = moment(this.dateRangeForm.value.start).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    this.endDate = moment(this.dateRangeForm.value.end).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    this.getFileClaimList();
    this.getKpiData();
  }
  clearDateRange(){
    this.dateRangeForm.patchValue({
      start: null,
      end: null
    });
    this.startDate = null;
    this.endDate = null;
    this.getFileClaimList();
    this.getKpiData();
  }
  getServices() {
      this.apiservice
        .get(endpoints.partners.serviceProvider.getServices)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (res: HttpResponse<any>) => {
            if (res?.body) {
              this.services = res.body?.services;
            }
          },
          error: (err: HttpErrorResponse) => {
            this.apiservice.alert(err.message, ErrorType.Error);
          },
        });
    }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
